import React, { FunctionComponent } from 'react'
import { SortableElement } from 'react-sortable-hoc'

import NavigationItem from '../NavigationItem'
import { IPageItem } from '../../../../../shared-ui/src/types/page'

import { Wrapper } from './style'

type Props = {
  items: IPageItem[]
  currentPage: IPageItem
  open: boolean
  pages?: IPageItem[]
  isDragActive: boolean
}

const SortableNavigationItem = SortableElement(NavigationItem)

const NavigationList: FunctionComponent<Props> = ({ items, currentPage, pages, open, isDragActive }: Props) => {
  const mainLevel = items.filter((item) => item.parent === null || item.parent === item.id)

  return (
    <Wrapper isDragActive={isDragActive} open={open}>
      <div className="inner-wrapper">
        {mainLevel.map((page, i) => {
          return (
            <SortableNavigationItem
              /* @ts-expect-error */
              item={page}
              open={open}
              isActive={page.id === currentPage.id}
              index={i}
              pages={pages}
              subPages={items.filter((item) => item.parent === page.id && item.parent !== item.id)}
              key={`navitem${page.id}`}
              isDragActive={isDragActive}
            />
          )
        })}
      </div>
    </Wrapper>
  )
}

export default NavigationList
